import styled from 'styled-components';
import { BreakPoints } from '@makemydeal/dr-ui-bricks-utils';

/**
 * Common shell wrapper shared by both layout variants. Owns the blue page
 * background so the chrome stays consistent regardless of variant.
 */
export const PageLayoutRoot = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 1 0;
    width: 100%;
    background-color: ${(props) => props.theme.uiBricks?.primaryAccentColor || '#0A468D'};
`;

export const SidebarLayoutContainer = styled.div`
    display: flex;
    flex: 1 1 0;
    height: 100%;
    overflow: hidden;

    /* Tablet (<= 768px): left nav becomes a fixed overlay drawer; main fills the row */
    @media (max-width: ${BreakPoints.TABLET}) {
        overflow: visible;
    }
`;

export const PageLayoutContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;
    width: 100%;
    min-height: 100%;
    padding: 16px;
    gap: 30px;
    overflow: auto;

    @media (max-width: ${BreakPoints.PHONE}) {
        padding: 12px;
    }
`;

export const BackButton = styled.button`
    display: inline-flex;
    align-items: center;
    align-self: flex-start;
    gap: 4px;
    padding: 8px 16px 8px 12px;
    border: none;
    border-radius: 24px;
    background-color: ${(props) => props.theme.uiBricks?.modalBackgroundColor || '#ffffff'};
    color: ${(props) => props.theme.uiBricks?.primaryAccentColor || '#0A468D'};
    font-size: ${(props) => props.theme.uiBricks?.baseFontSizeDesktop || '16px'};
    font-weight: ${(props) => props.theme.uiBricks?.primaryFontWeight || '400'};
    line-height: 1;
    cursor: pointer;

    &:hover {
        background-color: ${(props) => props.theme.uiBricks?.priceHeaderLinearBackground || '#f4f4f4'};
    }

    &:focus-visible {
        outline: 2px solid ${(props) => props.theme.uiBricks?.primaryAccentColor || '#0A468D'};
        outline-offset: 2px;
    }

    svg {
        width: 16px;
        height: 16px;
    }
`;

export const PageLayoutBody = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    flex: 1 1 auto;
    background-color: ${(props) => props.theme.uiBricks?.priceHeaderLinearBackground || '#f4f4f4'};
    border-radius: 24px;
    overflow: hidden;
    gap: 30px;
`;
